const Wrapper = require('../Wrapper');
const FilteringWrapper = require('./FilteringWrapper');
const SortingWrapper = require('./SortingWrapper');
const ResultItemsWrapper = require('./ResultItemsWrapper');
const PaginationWrapper = require('./PaginationWrapper');
const SelectricWrapper = require('../SelectricWrapper');

class SearchWrapper extends Wrapper {
    constructor() {
        super();

        if (document.getElementById('filtering')) {
            this._filtering = new FilteringWrapper('filtering');
        } else {
            this._filtering = null;
        }

        this.resultItems = new ResultItemsWrapper("ResultItems");

        this.pagination = new PaginationWrapper('more');

        this.sorting = new SortingWrapper('sorting');

        this.resultItemsfType = new SelectricWrapper(document.getElementById('resultItemsfType'));

        this.model = {
            filtering: this.filtering.model,
            page: this.pagination.model.page,
            sort: this.sorting.model
        };

        this.initEvents();
    }

    get filtering() {
        if (this._filtering !== null)
            return this._filtering;
        else
            return {
                model: null,
                addListener: () => {
                }
            }
    }

    async showResult(replace = true) {
        this.resultItems.loader(true, replace);

        let items = await this.resultItems.getItemsBySearchModel(this.model);

        this.resultItems.loader(false);

        this.resultItems.show(items, replace);

        // show and hide pagination depending on is there items to load
        if(items.length < 10)
            this.pagination.hide();
        else
            this.pagination.show();

        if(replace) this.pagination.reset();
    }

    initEvents() {
        this.filtering.addListener(() => {
            this.updateModel({filtering: this.filtering.model});
        });

        this.sorting.addListener(async () => {
            this.updateModel({sort: this.sorting.model});

            await this.showResult();
        });

        this.pagination.addListener(async () => {
            this.updateModel({ page: this.pagination.model.page});
            await this.showResult(false);
        });

        let searchBtn = document.getElementById('search');

        if (searchBtn)
            searchBtn.addEventListener('click', async () => {
                await this.showResult();
            });

        if(this._filtering === null) {
            this.resultItemsfType.$element.parents('li').removeClass('d-none')
            this.resultItemsfType.addListener(async () => {
                this.updateModel({ filtering: { type: this.resultItemsfType.model.value }});

                await this.showResult();
            });
        }
    }
}

module.exports = SearchWrapper;